export const NHOM_KHACHHANG_LIST_INITING             = 'NHOM_KHACHHANG_LIST_INITING'
export const NHOM_KHACHHANG_LIST_REQUESTING          = 'NHOM_KHACHHANG_LIST_REQUESTING'
export const NHOM_KHACHHANG_LIST_SUCCESS             = 'NHOM_KHACHHANG_LIST_SUCCESS'
export const NHOM_KHACHHANG_LIST_ERROR               = 'NHOM_KHACHHANG_LIST_ERROR'   

export const NHOM_KHACHHANG_DETAIL_INITING           = 'NHOM_KHACHHANG_DETAIL_INITING'
export const NHOM_KHACHHANG_DETAIL_REQUESTING        = 'NHOM_KHACHHANG_DETAIL_REQUESTING'
export const NHOM_KHACHHANG_DETAIL_SUCCESS           = 'NHOM_KHACHHANG_DETAIL_SUCCESS'
export const NHOM_KHACHHANG_DETAIL_ERROR             = 'NHOM_KHACHHANG_DETAIL_ERROR'   

export const NHOM_KHACHHANG_UPDATE_REQUESTING        = 'NHOM_KHACHHANG_UPDATE_REQUESTING'
export const NHOM_KHACHHANG_UPDATE_SUCCESS           = 'NHOM_KHACHHANG_UPDATE_SUCCESS'
export const NHOM_KHACHHANG_UPDATE_ERROR             = 'NHOM_KHACHHANG_UPDATE_ERROR'  

export const NHOM_KHACHHANG_REMOVE_REQUESTING        = 'NHOM_KHACHHANG_REMOVE_REQUESTING'
export const NHOM_KHACHHANG_REMOVE_SUCCESS           = 'NHOM_KHACHHANG_REMOVE_SUCCESS'
export const NHOM_KHACHHANG_REMOVE_ERROR             = 'NHOM_KHACHHANG_REMOVE_ERROR' 

export const NHOM_KHACHHANG_DETAIL_API               = '/api/v1/nhomkhachhang/nhomkhachhang_detail_by_id'  
export const NHOM_KHACHHANG_LIST_API                 = '/api/v1/nhomkhachhang/nhomkhachhang_list_by_store'   
export const NHOM_KHACHHANG_UPDATE_API               = '/api/v1/nhomkhachhang/nhomkhachhang_update_by_id'
export const NHOM_KHACHHANG_REMOVE_API               = '/api/v1/nhomkhachhang/nhomkhachhang_remove_by_id'  


// WEBPACK FOOTER //
// ./src/views/NhomKhachHang/constants.js